import { combineReducers } from 'redux';

import payment from './payment';

const reducer = combineReducers({
  [payment.name]: payment.reducer,
});

export default reducer;
